module.exports = __webpack_public_path__ + "static/media/hohepa-logo-220.c27d4b8c.png";